import { addon } from './tools/addon/'
import { tools } from './tools/tools'
import myStore from './tools/store'
export default {
  addon,
  tools,
  myStore
}



// WEBPACK FOOTER //
// ./src/utils/index.js